import styled from 'styled-components'

export const CheckBoxImg = styled.img`
height: 1.7em;
width: 1.7em;
cursor: ${({disabled=false}) => {
  return disabled ? 'auto': 'pointer'
}};
`